module.exports = __webpack_public_path__ + "img/music-test-icon7.daa860b4.png";